import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Category } from '../category.model';
import { CategoryService } from '../category.service';

@Component({
  selector: 'app-categorylst',
  templateUrl: './categorylst.component.html',
  styleUrls: ['./categorylst.component.css'],
  queries: {
    contentRef: new ViewChild("Modal")
  },
})
export class CategorylstComponent implements OnInit {

  Categories: Category[] = [];
  displayedColumns: string[] = ['id', 'arabicName', 'englishName', 'availableCost', 'imageUrl', "edit", "delete"];
  dataSource!: MatTableDataSource<Category>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  category: Category = {} as Category;
  Catgstatus: { id: number, name: string }[] = [];

  selectedStatus: number = 1;

  imagPath: any;
  pageSize = 100;
  constructor(private service: CategoryService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private localStorage: LocalStorageService,
    private globle: Globle,
    private translate: TranslateService) {
    var lang = this.localStorage.retrieve("lang");
    lang == 0 ? this.translate.use('en') : this.translate.use('ar');
  }

  ngOnInit() {
    this.Catgstatus = [{ id: 1, name: "active" }, { id: 0, name: "notActive" }];
    this.selectedStatus = 1;
    this.imagPath = this.globle.imgPath;
    this.pageSize = this.globle.pageSize;
    this.getCategory();
  }


  getCategory() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedStatus).subscribe(data => {
      this.Categories = data.sort((n1, n2) => n2.id - n1.id);

      this.dataSource = new MatTableDataSource(this.Categories);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.router.navigate(['./master/cards/addcategory']);
  }

  edit(id: number) {
    this.router.navigate(['./master/cards/editcategory/' + id]);
  }

  onDelete(id: number) {
    this.category.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.category.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getCategory();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectChange() {
    this.getCategory();
  }

  getTotalAvailableCostPrice() {

    return this.Categories.map(t => t.availableCost).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

}
